import React, { useState, useEffect, useCallback } from "react";
import { connect } from 'react-redux';
import LicensePrototypeForm from "./LicensePrototypeForm";
import * as Yup from "yup";
import * as actions from './store/licensePrototypeActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";
import { parseURL } from "../../sc-utilities";
import { CircularProgress } from "@material-ui/core";
import { CancelToken } from 'axios';
import {usedFor} from "./LicensePrototypeCreate";

const LicensePrototypeEdit = props => {
    const { activeCustomerID, translations, permissions, onEditLicensePrototype, onListPermissions, onLoadLicensePrototype, licensePrototype, onLoadLicensePrototypeInit } = props;
    const [editData, setEditData] = useState({ permissions: [], formattedPermissions: [], formattedUsedFor: [], hardware: '', loadingData: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            await onLoadLicensePrototype({ ActiveCustomerID: activeCustomerID, LicensePrototypeID: parseURL(window.location.href).licensePrototypeID }, { CancelToken: requestToken.token });
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
            onLoadLicensePrototypeInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const formatPermissions = useCallback(async (permissions = [], licensePrototypePermissions = []) => {
        return permissions.filter(permission => licensePrototypePermissions.includes(permission.value));
    }, [])

    const formatUsedFor = useCallback(async (licensePrototypeUsedFor = []) => {
        return usedFor.filter(usedForEl => licensePrototypeUsedFor.includes(usedForEl.value));
    }, [])

    const formatLicensePrototypeData = useCallback(async (licensePrototype, requestToken) => {
        let permissions = await onListPermissions({ ActiveCustomerID: activeCustomerID }, { cancelToken: requestToken.token });
        const configuration = licensePrototype && licensePrototype.Configuration && typeof licensePrototype.Configuration === 'string' ? JSON.parse(licensePrototype.Configuration) : null;
        let formattedPermissions = await formatPermissions(permissions, configuration.Permissions);
        let formattedUsedFor = await formatUsedFor(configuration.UsedFor);
        setEditData({ permissions: permissions, formattedPermissions: formattedPermissions, formattedUsedFor: formattedUsedFor, hardware: configuration.Hardware, loadingData: false });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const requestToken = CancelToken.source();
        if (licensePrototype && Object.keys(licensePrototype).length > 0 && licensePrototype.Configuration) {
            formatLicensePrototypeData(licensePrototype, requestToken);
        }
        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [licensePrototype]);

    const extractUsedFor = selectedUsedFor => {
        return selectedUsedFor.map(usedFor => usedFor.value);
    }

    const extractPermissions = selectedPermission => {
        return selectedPermission.map(permission => permission.value);
    }

    const handleSubmit = async data => {
        let formData = {};
        const configuration = JSON.stringify({
            UsedFor: extractUsedFor(data.UsedFor),
            Permissions: extractPermissions(data.Permissions),
            Hardware: data.Hardware
        });
        formData['Name'] = data.Name;
        formData['Configuration'] = configuration;
        formData['LicensePrototypeID'] = licensePrototype.LicensePrototypeID;

        let result = await onEditLicensePrototype({ ...formData, ActiveCustomerID: activeCustomerID });
        if (result) {
            setEditData({ permissions: [], formattedPermissions: [], formattedUsedFor: [], hardware: '', loadingData: true });
            History.goBack();
        }
    };

    let initialValues = {
        Name: licensePrototype && licensePrototype.Name ? licensePrototype.Name : '',
        Hardware: editData.hardware,
        UsedFor: editData.formattedUsedFor,
        Permissions: editData.formattedPermissions,
    };
    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
        },
        FormTitle: translations["edit_license_prototype"] || "Edit license prototype",
        ButtonSubmit: hasPermission(permissions, 'license_prototype_update') ? {
            Title: translations["save"] || "SAVE"
        } : null,
    };

    return !editData.loadingData ?
        <LicensePrototypeForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            permissions={editData.permissions}
            translations={translations}
            usedFor={usedFor}
        /> : <CircularProgress />;
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        licensePrototype: state.license.licensePrototypes.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onEditLicensePrototype: licensePrototype => dispatch(actions.editLicensePrototype(licensePrototype)),
        onListPermissions: (id) => dispatch(actions.listPermissions(id)),
        onLoadLicensePrototype: licensePrototype => dispatch(actions.loadLicensePrototype(licensePrototype)),
        onLoadLicensePrototypeInit: () => dispatch(actions.loadLicensePrototypeInit()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LicensePrototypeEdit);